import {
    REMOVE_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY,
    SAVE_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY,
    TEST_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY,
    WEBHOOK_SUBSCRIPTIONS_QUERY_KEY,
    WEBHOOK_SUBSCRIPTIONS_TOGGLE_MUTATION_KEY,
} from "./const";
import type { WebhookSubscriptionsQueryKeys } from "./types";

export const webhookSubscriptionsQueryKeys: WebhookSubscriptionsQueryKeys = {
    list: (): readonly string[] => [WEBHOOK_SUBSCRIPTIONS_QUERY_KEY],
    save: (): readonly string[] => [SAVE_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY],
    remove: (): readonly string[] => [REMOVE_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY],
    test: (): readonly string[] => [TEST_WEBHOOK_SUBSCRIPTIONS_MUTATION_KEY],
    toggle: (): readonly string[] => [WEBHOOK_SUBSCRIPTIONS_TOGGLE_MUTATION_KEY],
};
